/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CarveOutEligibilityReason = {
    IndividualThreshold: 'individual_threshold',
    CumulativeThreshold: 'cumulative_threshold',
    SpecificMedication: 'specific_medication',
    NoFdbPriceMatch: 'no_fdb_price_match',
    UserAdded: 'user_added',
} as const;
export type CarveOutEligibilityReason = typeof CarveOutEligibilityReason[keyof typeof CarveOutEligibilityReason];


export function instanceOfCarveOutEligibilityReason(value: any): boolean {
    for (const key in CarveOutEligibilityReason) {
        if (Object.prototype.hasOwnProperty.call(CarveOutEligibilityReason, key)) {
            if (CarveOutEligibilityReason[key as keyof typeof CarveOutEligibilityReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CarveOutEligibilityReasonFromJSON(json: any): CarveOutEligibilityReason {
    return CarveOutEligibilityReasonFromJSONTyped(json, false);
}

export function CarveOutEligibilityReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutEligibilityReason {
    return json as CarveOutEligibilityReason;
}

export function CarveOutEligibilityReasonToJSON(value?: CarveOutEligibilityReason | null): any {
    return value as any;
}

export function CarveOutEligibilityReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): CarveOutEligibilityReason {
    return value as CarveOutEligibilityReason;
}

